module.exports = __webpack_public_path__ + "img/icon.e31e1e6c.svg";